import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@grupoboticario/flora-react';
import { Button, ContentModal } from '../styles/ExtendedCaptation.styles';
import { ResponsiveFloraTypography } from 'ui/components/primitives';
import { useFeedbackMessage } from '../hooks/useFeedbackMessage';

const FeedbackMessage = () => {
  const { getTitle, avaliableCycles, getMessage, floraSection, goToHome } = useFeedbackMessage();

  return (
    <Modal open={true}>
      <ModalContent size="large" data-testid="extended-captation-modal">
        <ModalHeader>
          <ResponsiveFloraTypography as="h6" fontSize="subtitle" css={{ margin: 0 }}>
            {getTitle[avaliableCycles.status as keyof typeof getTitle]}
          </ResponsiveFloraTypography>
        </ModalHeader>
        <ModalBody>
          <ContentModal>
            {getMessage[avaliableCycles.status as keyof typeof getMessage]}
          </ContentModal>
        </ModalBody>
        <ModalFooter>
          <Button
            autotagging-flora="on"
            data-flora="button"
            data-flora-text={'Entendi'}
            data-autotagging-flora-section={
              floraSection[avaliableCycles.status as keyof typeof floraSection]
            }
            onClick={goToHome}
          >
            Entendi
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FeedbackMessage;
